<template>
  <section class="policy-section py-5">
    <div class="container">
      <!-- Titlu -->
      <div class="text-center mb-5">
        <i class="fa fa-user-secret fa-3x text-primary mb-3"></i>
        <h2 class="text-uppercase fw-bold text-primary">{{ t.title }}</h2>
        <p class="text-muted lead">{{ t.description }}</p>
      </div>

      <!-- Secțiuni Politică -->
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="policy-content bg-white shadow-sm rounded p-4">
            <template v-for="(section, index) in t.sections" :key="index">
              <h4 class="text-primary d-flex align-items-center" :class="{ 'mt-4': index > 0 }">
                <i :class="section.icon + ' me-2'"></i> {{ section.title }}
              </h4>
              <p class="text-muted" style="white-space: pre-line">{{ section.content }}</p>
            </template>

            <!-- Contact -->
            <h4 class="text-primary d-flex align-items-center mt-4">
              <i class="fa fa-envelope me-2"></i> {{ t.contact }}
            </h4>
            <p class="text-muted">{{ t.contactInfo }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PoliticaConfidentialitate",
  data() {
    return {
      translations: {
        ro: {
          title: "Politica de Confidențialitate",
          description: "Află cum colectăm și protejăm datele tale.",
          contact: "Contact",
          contactInfo: "Pentru orice întrebări, ne poți contacta la contact@feribot-eurobac.ro.",
          sections: [
            {
              icon: "fa fa-file",
              title: "1. Ce date colectăm?",
              content: "Colectăm date personale precum numele complet, adresa de email, numărul de telefon și, opțional, numărul de înmatriculare al autovehiculului. Acestea sunt necesare pentru emiterea biletelor, comunicarea cu clienții și personalizarea experienței. În unele cazuri, colectăm și date de facturare, cum ar fi adresa și CUI-ul firmei (dacă este cazul).\n\nDe asemenea, putem colecta date tehnice precum adresa IP, tipul de dispozitiv sau browserul utilizat, în scopuri de securitate și analiză. Toate datele sunt procesate conform legilor în vigoare."
            },
            {
              icon: "fa fa-database",
              title: "2. Cum utilizăm datele?",
              content: "Folosim datele colectate pentru a procesa comenzile de bilete și pentru a-ți trimite notificări legate de rezervări, plăți sau modificări de program. Datele mai pot fi utilizate pentru a oferi suport tehnic, a preveni fraude și a îmbunătăți platforma noastră.\n\nNu folosim datele tale în scopuri publicitare fără consimțământul tău explicit. Analizăm datele în mod anonim pentru a înțelege mai bine comportamentul utilizatorilor și pentru a optimiza serviciile oferite."
            },
            {
              icon: "fa fa-shield",
              title: "3. Protecția datelor",
              content: "Datele tale sunt stocate în sisteme securizate și accesate doar de personal autorizat. Utilizăm criptare, firewall-uri și alte măsuri de securitate pentru a preveni accesul neautorizat, pierderea sau manipularea datelor. Backup-urile sunt realizate periodic.\n\nPlățile sunt procesate exclusiv prin platforma externă BT PAY, iar Feribot Eurobac nu are acces la datele cardului tău sau alte informații sensibile. Respectăm standardele de securitate PCI-DSS aplicabile în domeniul plăților."
            },
            {
              icon: "fa fa-thumb-tack",
              title: "4. Cookie-uri și tehnologii similare",
              content: "Utilizăm cookie-uri pentru a îmbunătăți funcționarea site-ului, a analiza traficul și a salva preferințele tale. Acestea pot include cookie-uri esențiale, de analiză sau funcționale. Unele cookie-uri sunt plasate de terți, precum Google Analytics.\n\nAi opțiunea de a accepta sau refuza cookie-urile neesențiale. Poți modifica setările în browserul tău sau în bannerul de consimțământ afișat la prima vizită."
            },
            {
              icon: "fa fa-balance-scale",
              title: "5. Drepturile utilizatorului",
              content: "Ai dreptul să soliciți acces la datele tale, să le modifici, ștergi sau să restricționezi prelucrarea acestora. De asemenea, poți solicita portabilitatea datelor sau să te opui prelucrării automate.\n\nOrice solicitare se poate face prin email, iar răspunsul se va oferi în cel mult 30 de zile. Ai și dreptul să depui plângere la ANSPDCP dacă consideri că ți-au fost încălcate drepturile."
            },
            {
              icon: "fa fa-globe",
              title: "6. Transferul și stocarea datelor",
              content: "Datele tale sunt stocate pe servere situate în Uniunea Europeană. În cazuri excepționale, anumite servicii tehnice (ex. de backup) pot implica transferul datelor în afara UE, dar doar către țări cu un nivel adecvat de protecție.\n\nNe asigurăm că toate transferurile respectă regulamentele europene privind protecția datelor și includ clauze contractuale standard, dacă este cazul."
            },
            {
              icon: "fa fa-share-alt",
              title: "7. Partajarea cu terți",
              content: "Nu vindem și nu partajăm datele tale personale cu terți în scopuri comerciale. Putem transmite date doar către parteneri de încredere (ex: procesatori de plăți sau furnizori de suport tehnic), exclusiv în măsura în care este necesar.\n\nToți partenerii noștri sunt obligați contractual să respecte normele GDPR și să nu folosească datele în alte scopuri."
            },
            {
              icon: "fa fa-edit",
              title: "8. Modificări ale politicii",
              content: "Ne rezervăm dreptul de a actualiza Politica de Confidențialitate în orice moment. Orice modificare importantă va fi semnalizată pe site, iar versiunea actuală va fi disponibilă mereu pentru consultare.\n\nContinuarea utilizării platformei după modificări înseamnă că accepți noua politică. Data ultimei actualizări este afișată la finalul documentului."
            }
          ]
        },
        en: {
          title: "Privacy Policy",
          description: "Find out how we collect and protect your data.",
          contact: "Contact",
          contactInfo: "For any questions, contact us at contact@feribot-eurobac.ro.",
          sections: [
            {
              icon: "fa fa-file",
              title: "1. What data do we collect?",
              content: "We collect personal data such as your full name, email address, phone number, and optionally, your vehicle registration number. These are required to issue tickets, communicate with users, and personalize your experience. We may also collect billing data and company details (if applicable).\n\nTechnical data such as IP address, device type or browser may be collected for analytics and security purposes. All data is processed according to applicable laws."
            },
            {
              icon: "fa fa-database",
              title: "2. How do we use the data?",
              content: "We use your data to process ticket orders, send notifications, and provide technical support. We may also use it to prevent fraud and analyze user behavior to improve our platform.\n\nWe do not use your data for marketing unless you have given explicit consent. Data is anonymized for analytical purposes."
            },
            {
              icon: "fa fa-shield",
              title: "3. Data protection",
              content: "Your data is stored in secure systems and accessible only by authorized personnel. We apply encryption, firewalls, and regular backups to ensure data safety.\n\nAll payments are securely handled by the BT PAY platform. Feribot Eurobac does not store any card data or payment credentials."
            },
            {
              icon: "fa fa-thumb-tack",
              title: "4. Cookies and similar technologies",
              content: "We use cookies to improve site functionality, analyze traffic, and remember your preferences. These include essential, functional, and analytics cookies.\n\nYou may opt-in or opt-out of non-essential cookies via your browser or the consent banner displayed at first visit."
            },
            {
              icon: "fa fa-balance-scale",
              title: "5. Your rights",
              content: "You have the right to access, correct, delete, or restrict the processing of your data. You may also request data portability or object to automated processing.\n\nWe respond to all requests within 30 days. You may file a complaint with your local data protection authority if needed."
            },
            {
              icon: "fa fa-globe",
              title: "6. Data storage and transfers",
              content: "Your data is stored on servers located within the European Union. In some cases, it may be processed outside the EU, but only under strict GDPR-compliant conditions.\n\nWe ensure that any transfers outside the EU are secured using appropriate safeguards."
            },
            {
              icon: "fa fa-share-alt",
              title: "7. Sharing with third parties",
              content: "We do not sell or share your personal data for marketing purposes. Data is shared only with trusted partners such as payment processors or technical support providers, and only when necessary.\n\nAll our partners are contractually bound to GDPR standards and cannot use the data for other purposes."
            },
            {
              icon: "fa fa-edit",
              title: "8. Policy changes",
              content: "We reserve the right to update this Privacy Policy at any time. Major updates will be announced on our website.\n\nContinued use of the platform after such updates implies acceptance of the new policy. The latest version will always be available on our site."
            }
          ]
        },
        bg: {
          title: "Политика за поверителност",
          description: "Разберете как събираме и защитаваме вашите данни.",
          contact: "Контакт",
          contactInfo: "При въпроси, свържете се с нас на contact@feribot-eurobac.ro.",
          sections: [
            {
              icon: "fa fa-file",
              title: "1. Какви данни събираме?",
              content: "Събираме лични данни като пълно име, имейл адрес, телефонен номер и по избор регистрационен номер на автомобила. Те са необходими за издаване на билети, комуникация с клиенти и персонализиране на услугите.\n\nСъщо така можем да събираме технически данни като IP адрес, тип устройство или браузър за аналитични и защитни цели. Всички данни се обработват в съответствие със закона."
            },
            {
              icon: "fa fa-database",
              title: "2. Как използваме данните?",
              content: "Използваме данните за обработка на поръчки, изпращане на уведомления и предоставяне на техническа поддръжка. Можем да ги използваме и за предотвратяване на измами и за подобряване на платформата.\n\nНие не използваме вашите данни за маркетингови цели без вашето изрично съгласие. Данните се анализират в анонимен вид."
            },
            {
              icon: "fa fa-shield",
              title: "3. Защита на данните",
              content: "Вашите данни се съхраняват в защитени системи с ограничен достъп само за упълномощени служители. Използваме криптиране, защитни стени и редовни архиви за сигурност.\n\nВсички плащания се обработват чрез външната платформа BT PAY. Feribot Eurobac не съхранява данни за карти или чувствителна платежна информация."
            },
            {
              icon: "fa fa-thumb-tack",
              title: "4. Бисквитки и подобни технологии",
              content: "Използваме бисквитки за подобряване на функционалността на сайта, анализ на трафика и запазване на вашите предпочитания. Това включва основни, аналитични и функционални бисквитки.\n\nМожете да приемете или откажете неосновните бисквитки чрез настройките на браузъра или банера за съгласие."
            },
            {
              icon: "fa fa-balance-scale",
              title: "5. Вашите права",
              content: "Имате право на достъп, коригиране, изтриване или ограничаване на обработката на вашите данни. Също така можете да поискате преносимост или да възразите срещу автоматизирана обработка.\n\nОтговаряме на всички заявки в рамките на 30 дни. Можете да подадете жалба до Комисията за защита на личните данни (КЗЛД), ако е необходимо."
            },
            {
              icon: "fa fa-globe",
              title: "6. Съхранение и прехвърляне на данни",
              content: "Вашите данни се съхраняват на сървъри в Европейския съюз. В някои случаи е възможна обработка извън ЕС, но само при спазване на регламентите на GDPR.\n\nГарантираме, че всяко прехвърляне извън ЕС е защитено с подходящи мерки."
            },
            {
              icon: "fa fa-share-alt",
              title: "7. Споделяне с трети страни",
              content: "Не продаваме и не споделяме вашите лични данни за маркетингови цели. Данните се споделят само с доверени партньори като процесори на плащания и техническа поддръжка, само когато е необходимо.\n\nВсички партньори са договорно задължени да спазват стандартите на GDPR."
            },
            {
              icon: "fa fa-edit",
              title: "8. Промени в политиката",
              content: "Запазваме си правото да актуализираме тази политика по всяко време. Всички важни промени ще бъдат обявени на уебсайта.\n\nПродължаването на използването след промени означава, че приемате новите условия. Последната версия винаги ще бъде налична онлайн."
            }
          ]
        }
      }
    };
  },
  computed: {
    currentLocale() {
      // Try to detect locale from i18n; fallback to 'ro'
      try {
        return this.$i18n && this.$i18n.locale ? this.$i18n.locale : "ro";
      } catch (e) {
        return "ro";
      }
    },
    t() {
      return this.translations[this.currentLocale] || this.translations.ro;
    }
  }
};
</script>

<style scoped>
.policy-section {
  background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
}
.policy-content {
  border-left: 5px solid #0056b3;
}
.policy-content h4 {
  font-weight: 600;
  font-size: 1.25rem;
}
.policy-content p {
  font-size: 1rem;
  line-height: 1.7;
}
</style>